module.exports = __webpack_public_path__ + "static/media/non_existent.c80500ef.png";